import MemberProfileAvatar from "app/components/MemberProfileAvatar";
import CustomTooltip from "app/components/Tooltip";
import React from "react";

interface CustomProps {
  value: string;
}

const Creator: React.FC<CustomProps> = ({ value }) => {

  return (
    <>
      <button className="flex items-center hover:border hover:border-[#BDC0C3] p-[4px] rounded-[2px] min-w-0 w-full overflow-hidden cursor-pointer">
        <CustomTooltip text="Creator" className="flex items-center w-full min-w-0">
          <div className="flex items-center gap-2 w-full min-w-0 overflow-hidden">
            <MemberProfileAvatar
              id={value}
              containerClassName="min-w-0 overflow-hidden"
              circleClassName="!size-4"
              nameClassName="truncate"
              initialsClassName=" !text-[8px]"
            />
          </div>
        </CustomTooltip>
      </button>
    </>
  );
};

export default Creator;
